// Product list pagination
function updatePagination(){
	var current_url = new URL(window.location),
		current_page = parseInt(current_url.searchParams.get('page')) || 1,
		count = parseInt($('#main').data('list_count')),
		pagination = '', pagination_prev = '', pagination_next = '',
		page_limit = parseInt($('#main').data('list_pagelimit')),
		remaining = parseInt($('#main').data('list_remaining')),
		remaining_pages = Math.ceil(remaining / page_limit);

	// prev pages + current
	for (let i = 1; i <= current_page; i++){
		current_url.searchParams.set('page', i);
		pagination_prev += `<a class="page page--${i==current_page ? 'current' : 'prev'}" href="${current_url}">${i}</a>`;
	}

	// next pages
	if (remaining_pages > 0){
		for (let i = 1; i <= remaining_pages; i++){
			current_url.searchParams.set('page', i + current_page);
			pagination_next += `<a class="page page--next" href="${current_url}">${i + current_page}</a>`;
		}
	}

	// fill component
	pagination = `<div class="pagination__prev">${pagination_prev}</div><div class="pagination__next">${pagination_next}</div>`;

	// update on page
	$('.pagination__row').html(pagination);
	
	// show or hide pagination, if found products
	if (count > 0)
	{
		$('.pagination__row').show();
    }
	else
	{
		$('.pagination__row').hide();
	}
};